import { render, staticRenderFns } from "./IconInbox.vue?vue&type=template&id=5cab9662"
import script from "./IconInbox.vue?vue&type=script&lang=ts"
export * from "./IconInbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports